import Swiper, { Autoplay, Lazy } from "swiper";

class PartnersSlider {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    const partnersCount = this.wrapper.find(".partners__slider .swiper-wrapper")[0].children.length;

    new Swiper(this.wrapper.find(".partners__slider")[0], {
      modules: [Lazy, Autoplay],
      spaceBetween: 20,
      slidesPerView: "auto",
      loop: true,
      speed: 4000, // how long one full transition takes
      autoplay: {
        delay: 0, // continuous motion
        disableOnInteraction: false,
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 4,
      },
    });
  }
}

export default PartnersSlider;